// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between;width:100%}
`, "",{"version":3,"sources":["webpack://./src/ReadAndWrite/pages/InfoPage/styles.scss"],"names":[],"mappings":"AAAA,KACE,YAAa,CACb,kBAAmB,CACnB,cAAe,CACf,6BAA8B,CAC9B,UAAW","sourcesContent":[".row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
